<div class="page-title">
  <h1>Usuários cadastrados</h1>
  @if(canAddUser()) {
    <button matButton="filled" (click)="addAction()">
    <span style="margin-right: 6px; font-size: 16px">+</span> Adicionar
  </button>
  }
</div>

<div class="filtros">
  <mat-form-field appearance="outline" style="width: 30%">
    <mat-select
      [(ngModel)]="filtroTipoPerfil"
      (selectionChange)="aplicarFiltro()"
    >
      <mat-option selected value="">Perfil de acesso</mat-option>
      <mat-option
        *ngFor="let option of filtroTipoPerfilOptions"
        [value]="option.value"
      >
        {{ option.label }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" style="width: 70%">
    <mat-label>Buscar por nome e empresa</mat-label>
    <input
      matInput
      [(ngModel)]="filtroNome"
      placeholder="Buscar por nome e empresa"
      (keyup)="aplicarFiltro()"
    />
  </mat-form-field>
</div>

<table mat-table [dataSource]="datasource" class="cis-default-table" matSort>
  <ng-container matColumnDef="nome">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome</th>
    <td mat-cell *matCellDef="let row">
      <span style="font-weight: 600">{{ row.nome }}</span>
    </td>
  </ng-container>

  <ng-container matColumnDef="empresa">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Empresa</th>
    <td mat-cell *matCellDef="let row">
      {{ row.empresaResumo.nomeFantasia ?? '-' }}
    </td>
  </ng-container>

  <ng-container matColumnDef="perfil_de_acesso">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Perfil de acesso</th>
    <td mat-cell *matCellDef="let row">{{ getPerfisNomes(row) }}</td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
    <td mat-cell *matCellDef="let row">
      @if(row.status.toUpperCase() === 'ATIVO') {
      <span class="status-pill status-active">Ativo</span>
      } @else if (row.status.toUpperCase() === 'BLOQUEADO') {
      <span class="status-pill status-inactive">Inativo</span>
      } @else if (row.status.toUpperCase() === 'PENDENTE') {
      <span class="status-pill status-pendente">Pendente</span>
      } @else {
      <span class="status-pill status-inactive">Inativo</span>
      }
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns" class="header"></tr>
  <tr
    mat-row
    (click)="abreTelaParaAtualizacao(row)"
    *matRowDef="let row; columns: displayedColumns"
  ></tr>
</table>

<div class="paginator-container">
  <p class="contagem-resultados">{{ textoContagem }}</p>
  <mat-paginator
    [length]="total"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    (page)="onPageChange($event)"
    [showFirstLastButtons]="false"
    [hidePageSize]="false"
    aria-label="Selecionar página"
  >
  </mat-paginator>
</div>
